export default function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_aperture.js
// module id = SKOc
// module chunks = 0